import { isFunction, isObject } from 'lodash'
export function transformTipsOptions (column, headerTipOptions = {}) {
  const { key, headerTip } = column
  const tipsOpion = headerTipOptions[key]
  if (tipsOpion) {
    if (isFunction(tipsOpion)) {
      return {
        tipsContentRender: (h) => h('div', {
          domProps: {
            innerHTML: tipsOpion({column})
          }
        }),
      }
    } else if (isObject(tipsOpion)) {
      return {
        ...tipsOpion,
      }
    }
    return {}
  } else {
    return {
      tipsContent: headerTip
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/transform-tips-options.js